'use client';

import { Button, TextField } from '@paction-2.0/ui';
import { FormEvent, useState } from 'react';

import styles from '../styles/mailingListForm.module.scss';

type MailingListFormProps = {
  description?: string;
};

export function MailingListForm({
  description = 'Stay updated with more webinars, breeding tips, and industry insights.'
}: MailingListFormProps) {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsLoading(true);
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: 'Webinar Subscriber',
          email,
          phone: '',
          role: 'subscriber',
          info: 'Webinar mailing list subscription'
        })
      });
      if (res.ok) {
        setSent(true);
      }
    } catch {
      // Silently fail
    } finally {
      setIsLoading(false);
    }
  };

  if (sent) {
    return (
      <div className={styles.mailingListForm}>
        <h3 className={styles.title}>Thank you!</h3>
        <p className={styles.description}>
          We&apos;ll keep you updated with more webinars and breeding insights.
        </p>
      </div>
    );
  }

  return (
    <form className={styles.mailingListForm} onSubmit={handleSubmit}>
      <p className={styles.description}>{description}</p>
      <div className={styles.formRow}>
        <div className={styles.fieldWrapper}>
          <TextField
            type="email"
            name="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className={styles.buttonWrapper}>
          <Button type="submit" disabled={isLoading || !email.trim()}>
            {isLoading ? 'Subscribing...' : 'Subscribe'}
          </Button>
        </div>
      </div>
    </form>
  );
}
